import React from "react";
import { SFLoadingSpinner } from "@sf-core";

const LoadingScreen = () => (
  <div style={{
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "#fff",
    zIndex: 99999,
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
    justifyItems: "center",
    pointerEvents: "none"
  }}>
    <SFLoadingSpinner />
  </div>
);

export default LoadingScreen;

